import api from "./core";

const basePath = "api/core/MarsRecords";

export default {
  get(id, extraHeaders = {}) {
    return api.get(`${basePath}/${id}`, extraHeaders);
  },
  query(filter, extraHeaders = {}) {
    return api.post(`${basePath}`, filter, extraHeaders);
  },
  update(id, data) {
    return api.patch(`${basePath}/${id}`, data);
  },
  create(data) {
    return api.put(`${basePath}`, data);
  },
  delete(id) {
    return api.delete(`${basePath}/${id}`);
  }
};
